// Small sci illustrations
import cElegansSci from "@/assets/organism/sciIllustration/c-elegans-360w.avif";
import dRerioSci from "@/assets/organism/sciIllustration/d-rerio-360w.avif";
import dMelanogasterSci from "@/assets/organism/sciIllustration/d-melanogaster-360w.avif";
import mMusculusSci from "@/assets/organism/sciIllustration/m-musculus-360w.avif";
import hSapiensSci from "@/assets/organism/sciIllustration/h-sapiens-360w.avif";

// Large sci illustrations
import cElegansSciLarge from "@/assets/organism/sciIllustration/c-elegans-1170w.avif";
import dRerioSciLarge from "@/assets/organism/sciIllustration/d-rerio-1170w.avif";
import dMelanogasterSciLarge from "@/assets/organism/sciIllustration/d-melanogaster-1170w.avif";
import mMusculusSciLarge from "@/assets/organism/sciIllustration/m-musculus-1170w.avif";
import hSapiensSciLarge from "@/assets/organism/sciIllustration/h-sapiens-1170w.avif";

// Small photos
import cElegansPhoto from "@/assets/organism/photo/c-elegans-360w.avif";
import dRerioPhoto from "@/assets/organism/photo/d-rerio-360w.avif";
import dMelanogasterPhoto from "@/assets/organism/photo/d-melanogaster-360w.avif";
import mMusculusPhoto from "@/assets/organism/photo/m-musculus-360w.avif";
import hSapiensPhoto from "@/assets/organism/photo/h-sapiens-360w.avif";

// Large photos
import cElegansPhotoLarge from "@/assets/organism/photo/c-elegans-1170w.avif";
import dRerioPhotoLarge from "@/assets/organism/photo/d-rerio-1170w.avif";
import dMelanogasterPhotoLarge from "@/assets/organism/photo/d-melanogaster-1170w.avif";
import mMusculusPhotoLarge from "@/assets/organism/photo/m-musculus-1170w.avif";
import hSapiensPhotoLarge from "@/assets/organism/photo/h-sapiens-1170w.avif";

// ----------------------------------------------------------------------------------

export const organismImgData = {
	"C. elegans": {
		// Sci illustration
		imageSci: cElegansSci,
		classNameSci: "c-elegans",
		imageSciLarge: cElegansSciLarge,
		classNameSciLarge: "c-elegans-large",
		altSci: "Scientific illustration of C. elegans",
		citationSci:
			"Created in BioRender. B, D. (2025) https://BioRender.com/r26u649",
		// Photo
		imagePhoto: cElegansPhoto,
		classNamePhoto: "photo-small",
		imagePhotoLarge: cElegansPhotoLarge,
		classNamePhotoLarge: "photo-large",
		altPhoto: "Photo of C. elegans",
		citationPhoto: "kdfj",
	},

	"D. rerio": {
		// Sci illustration
		imageSci: dRerioSci,
		classNameSci: "d-rerio",
		imageSciLarge: dRerioSciLarge,
		classNameSciLarge: "d-rerio-large",
		altSci: "Scientific illustration of D. rerio",
		citationSci:
			"Created in BioRender. B, D. (2025) https://BioRender.com/d97l644",
		// Photo
		imagePhoto: dRerioPhoto,
		classNamePhoto: "photo-small",
		imagePhotoLarge: dRerioPhotoLarge,
		classNamePhotoLarge: "photo-large",
		altPhoto: "Photo of D. rerio",
		citationPhoto: "Stephen Ward from Oregon State University",
	},

	"D. melanogaster": {
		// Sci illustration
		imageSci: dMelanogasterSci,
		classNameSci: "d-melanogaster",
		imageSciLarge: dMelanogasterSciLarge,
		classNameSciLarge: "d-melanogaster-large",
		altSci: "Scientific illustration of D. melanogaster",
		citationSci:
			"Created in BioRender. B, D. (2025) https://BioRender.com/l43j843",
		// Photo
		imagePhoto: dMelanogasterPhoto,
		classNamePhoto: "photo-small",
		imagePhotoLarge: dMelanogasterPhotoLarge,
		classNamePhotoLarge: "photo-large",
		altPhoto: "Photo of D. melanogaster",
		citationPhoto: "Alexis Tinker-Tsavalas",
	},

	"M. musculus": {
		// Sci illustration
		imageSci: mMusculusSci,
		classNameSci: "m-musculus",
		imageSciLarge: mMusculusSciLarge,
		classNameSciLarge: "m-musculus-large",
		altSci: "Scientific illustration of M. musculus",
		citationSci:
			"Created in BioRender. B, D. (2025) https://BioRender.com/t10k848",
		// Photo
		imagePhoto: mMusculusPhoto,
		classNamePhoto: "photo-small",
		imagePhotoLarge: mMusculusPhotoLarge,
		classNamePhotoLarge: "photo-large",
		altPhoto: "Photo of M. musculus",
		citationPhoto: "Nikolett Emmert",
	},

	"H. sapiens": {
		// Sci illustration
		imageSci: hSapiensSci,
		classNameSci: "h-sapiens",
		imageSciLarge: hSapiensSciLarge,
		classNameSciLarge: "h-sapiens-large",
		altSci: "Scientific illustration of H. sapiens",
		citationSci:
			"Created in BioRender. B, D. (2025) https://BioRender.com/p25k110",
		// Photo
		imagePhoto: hSapiensPhoto,
		classNamePhoto: "photo-small",
		imagePhotoLarge: hSapiensPhotoLarge,
		classNamePhotoLarge: "photo-large",
		altPhoto: "Photo of H. sapiens",
		citationPhoto: "Raamin Ka",
	},
};
